import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-WT8B4J79",
  // preview: `env-${APP_ENV}`,
};

export const initializeGTM = () => {
  TagManager.initialize(tagManagerArgs);
};
